<h2>Delta T sources</h2>

<table class="table mt-1">
  <thead>
    <tr>
      <th>Asset</th>
      <th>Gateway</th>
      <th>Site</th>
      <th>Value</th>
    </tr>
  </thead>
  <tbody>
    @for (asset of derivedAsset()?.children; track asset.id) {
      <tr>
        <td>{{ asset.title }}</td>
        <td>{{ asset.gateway.title }}</td>
        <td>{{ asset.siteTitle }}</td>
        <td>{{ asset.value }}</td>
      </tr>
    }
  </tbody>
</table>

@if (derivedAsset()?.children.length > 0) {
  <div class="mt-1 text-right dim" title="Calculation">{{ derivedAsset()?.children[0].value }} - {{ derivedAsset()?.children[1].value }} = {{ derivedAsset().parent.value }}</div>
}
